module.exports = __webpack_public_path__ + "img/banker-green_900.f4d01c8b.png";